import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Spin, Row, Input, Select, Divider, Button, Tooltip,Typography, Result } from 'antd';
import { schema_to_field } from '../../../lib/util';

import Form from '../../../lib/ui/form';
import { Cancel } from '@material-ui/icons';
const {Text,Paragraph,Title}=Typography;

const our_col_options = {
    'decimal': [
        {
            display_name: "Amount",
            key: 'amount',
            type: 'decimal'
        }
    ],
    'string': [
        {
            display_name: "Txn Type",
            key: 'type',
            type: 'string'
        },
        {
            display_name: "Txn ID",
            key: 'transaction_id',
            type: 'string'
        },
        {
            display_name: "Description",
            key: 'description',
            type: 'string'
        },
    ],
    'date': [
        {
            display_name: "Transaction Date",
            key: 'txn_date',
            type: 'date'
        }
    ]
};
const their_col_options = {
    'decimal': [
        {
            display_name: "Amount",
            key: 'amount',
            type: 'decimal'
        }
    ],
    'string': [
        {
            display_name: "Txn Type",
            key: 'type',
            type: 'string'
        },
        {
            display_name: "Txn ID",
            key: 'transaction_id',
            type: 'string'
        },
        {
            display_name: "Description",
            key: 'description',
            type: 'string'
        },
    ],
    'date': [
        {
            display_name: "Transaction Date",
            key: 'txn_date',
            type: 'date'
        }
    ]
}

const ERROR_STATUS='error',SUCCESS_STATUS='success';

class ReconcilerSmartActionsAddEdit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_data: this.props.data?JSON.parse(JSON.stringify(this.props.data)):{
                field_comparisons: [],
                value_comparisons: [],
                rule_id: this.props.recon_id
            },
            recon_id: this.props.recon_id,
            edit_id: this.props.action_id,
            // to compare two fields
            field_comparators: {},

            // to compare value of field
            value_comparators: {},

            //    for  plugin actions
            actions: {},

            pluginSchema: [],
            status:null

        };

        this.list_actionplugins = RESTExecutor.list().config({
            label: 'smart_actions_plugin',
            params: {
                id: (this.props.data && this.props.data.plugin_id)
            }
        })
            .callbacks((success) => {
                let actions = {};
                let current_action_id = (this.props.data && this.props.data.plugin_id);

                success.result.rows.map((item) => {
                    if (item.id === current_action_id) {
                        this.setState({
                            pluginSchema: schema_to_field(item.validation_config || {})
                        })
                    }
                    console.log("map actions", item)
                    actions[item.id] = item
                });
                this.setState({ actions: actions })

            })
            .connect(props.domains.settings);

        this.list_comparators = RESTExecutor.list().config({
            label: 'reconciler_comparators',
            params: {
                pagination: false
            }
        })
            .callbacks((success) => {
                let field_comparator_obj = {};
                let value_comparator_obj = {};
                success.result.rows.map((item) => {
                    if (item.type === 'field') {
                        field_comparator_obj[item.id] = item
                    } else if (item.type === 'value') {
                        value_comparator_obj[item.id] = item
                    }
                });
                this.setState({
                    value_comparators: value_comparator_obj,
                    field_comparators: field_comparator_obj
                })
            })
            .connect(props.domains.settings);

        this.post_recon_action=RESTExecutor.post().config({
            label:'smart_actions',
        }).callbacks((success)=>{
            this.setState({
                status:SUCCESS_STATUS
            })
        },(error)=>{
            let error_section = [];

            // console.log(Object.keys("dasdasd"))
            console.log("ERROR IS", error)
            if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                console.log("error is obj")
                error_section.push(<Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}
                    >
                        The content you submitted has the following error:
                </Text>

                </Paragraph>)
                Object.keys(error.validation_errors).map((key, index) => {
                    let error_item = error.validation_errors[key];
                    if (typeof error_item === 'string') {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                            </Paragraph>
                        )
                    }
                    else if (Array.isArray(error_item)) {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                            </Paragraph>
                        )
                    }
                })
            } else if (typeof error.error_message === 'string') {
                error_section.push(<Paragraph>
                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                </Paragraph>)
            }

            this.setState({
                status: ERROR_STATUS,
                error_section: error_section
            })
        }).connect(props.domains.settings);

        this.patch_recon_action=RESTExecutor.patch().config({
            label:'smart_actions_detail'
        }).forId("")
        .callbacks((success)=>{
            this.setState({
                status:SUCCESS_STATUS
            })
        },(error)=>{
            let error_section = [];

                // console.log(Object.keys("dasdasd"))
                console.log("ERROR IS", error)
                if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                    console.log("error is obj")
                    error_section.push(<Paragraph>
                        <Text
                            strong
                            style={{
                                fontSize: 16,
                            }}
                        >
                            The content you submitted has the following error:
                    </Text>

                    </Paragraph>)
                    Object.keys(error.validation_errors).map((key, index) => {
                        let error_item = error.validation_errors[key];
                        if (typeof error_item === 'string') {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                                </Paragraph>
                            )
                        }
                        else if (Array.isArray(error_item)) {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                                </Paragraph>
                            )
                        }
                    })
                } else if (typeof error.error_message === 'string') {
                    error_section.push(<Paragraph>
                        <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                    </Paragraph>)
                }

                this.setState({
                    status: ERROR_STATUS,
                    error_section: error_section
                })
        })
        .connect(props.domains.settings);

        this.list_actionplugins.execute();
        this.list_comparators.execute();


    };

    handlePostPatch=()=>{
        if (this.state.edit_id) {
            // patch/edit
            this.patch_recon_action.forId(this.state.edit_id).execute(this.state.form_data);

        } else {
            this.post_recon_action.execute(this.state.form_data)
            // post/add
        }
    }

    ruleAdder = ({ ruleKey }) => {
        let form_data = this.state.form_data;
        if (!Array.isArray(form_data[ruleKey])) {
            form_data[ruleKey] = []
        };
        form_data[ruleKey].push({});
        this.setState({
            form_data: form_data
        })
    }
    ruleDeleter = ({ ruleKey, index }) => {
        let form_data = this.state.form_data;
        if (Array.isArray(form_data[ruleKey])) {
            form_data[ruleKey].splice(index, 1)
        }
        this.setState({
            form_data: form_data
        })
    }
    ruleUpdater = ({ ruleKey, key, value, index }) => {
        let form_data = this.state.form_data;
        if (Array.isArray(form_data[ruleKey])) {
            if (!form_data[ruleKey][index]) {
                form_data[ruleKey][index] = {}
            }
            form_data[ruleKey][index][key] = value
        }
        this.setState({
            form_data: form_data
        })
    }

    stateUpdater = ({ stateKey, valueKey, value }) => {
        let newData = this.state[stateKey];
        newData[valueKey] = value;
        this.setState({
            [stateKey]: newData
        })
    }


    _generateValidationForm = (config, data, onChange) => {
        let schema = config || [];
        let fields = schema_to_field(schema);

        return <Form
            forCreate={true}
            initialData={data}
            submitted={false}
            onChange={onChange}
            fields={fields}
            errorMessage={{}}
            validationError={{}}
        />

    }

    render() {
        if (!this.props.recon_id) {
            return <center><Spin /></center>
        }
        const {status}=this.state;
        if(status===ERROR_STATUS){
            return <div> <Result

            status='error'
            title="Operation Failed"
            subTitle="Please check and modify the following information before resubmitting."
            // subTitle=""
            extra={[
                    <Button type="primary" key="console" onClick={()=>{
                        typeof this.props.onClose==='function'&& this.props.onClose()
                    }}>
                        Go Back
                    </Button>,

                <Button key="try_again" onClick={() => {
                    this.setState({
                        status: null,
                        error_section:null
                    })
                }}>Try Again</Button>,
            ]}
        />
            <div className="desc" style={{
                textAlign: 'left'
            }}>
                {this.state.error_section}
            </div>

        </div>
        }
        if(status===SUCCESS_STATUS){
            return <div> <Result
            status="success"
            title="Successfully completed operation on Smart Action"
            // subTitle=""
            extra={[
                    <Button type="primary" key="console" onClick={()=>{
                        typeof this.props.onClose==='function'&& this.props.onClose()
                    }}>
                        Go Back
                </Button>,
                // <Button key="add_again" onClick={() => {
                //     this.setState({
                //         form_data:{
                //             field_comparisons: [],
                //             value_comparisons: [],
                //             rule_id: this.props.recon_id
                //         },
                //         recon_id: this.props.recon_id,
                //         edit_id: null,    
                //         pluginSchema: [],
                //         status:null
                //     })
                // }}>Add Again</Button>,
            ]}
        />

        </div>
        }
        let list_actionplugins_resp = this.list_actionplugins.response();

        const { form_data, value_comparators, field_comparators, actions } = this.state;
        return (
            <div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Row type='flex' justify='center' style={{
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'right',
                            justifyContent: 'center'
                        }}
                        >
                            <span>
                                Action Name: &nbsp; <Input
                                    placeholder={"Action  Name"}
                                    onChange={(e) => {
                                        this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                                    }}
                                    value={form_data.name}
                                    style={{
                                        width: 300
                                    }} >
                                </Input>
                            </span>
                            <br></br>
                            <span>Action Plugin: <Select style={{ width: 300 }}
                                placeholder="Action Plugin"
                                filterOption={false}
                                onSearch={(value) => {
                                    this.list_actionplugins.config({
                                        params: {
                                            query: value
                                        }
                                    }).execute()
                                }}
                                showSearch
                                value={form_data.plugin_id}
                                onChange={(value) => {
                                    this.stateUpdater({
                                        stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                                            this.stateUpdater({ stateKey: 'form_data', valueKey: 'plugin_params', value: {} })
                                        }
                                    });
                                    this.setState({
                                        pluginSchema: schema_to_field(actions[value].validation_config || {})
                                    })
                                }}


                            >
                                {
                                    Object.keys(actions).map((key, index) => {
                                        let item = actions[key];
                                        return <Select.Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    })
                                }

                            </Select>
                            </span>
                            <br></br>
                            <span>
                                Action Order: &nbsp; <Input
                                    placeholder={"Action  Order"}
                                    onChange={(e) => {
                                        this.stateUpdater({ stateKey: 'form_data', valueKey: 'order', value: e.target.value })
                                    }}
                                    value={form_data.order}
                                    style={{
                                        width: 300
                                    }} >
                                </Input>
                            </span>
                            <br></br>
                        </div>
                    </Row>
                    <br></br>
                    {this.state.pluginSchema.length > 0 &&
                        <React.Fragment>
                            <Divider style={{ marginTop: 8, marginBottom: 8 }} />
                            <Title style={{ margin: 0 }} level={4} type='secondary'>Plugin Params</Title>
                            <Form
                                hideTitle
                                forCreate={true}
                                initialData={form_data.plugin_params || {}}
                                submitted={this.state.submitted}
                                onChange={(data) => {
                                    console.log("Changes", data);
                                    this.stateUpdater({
                                        stateKey: 'form_data',
                                        valueKey: 'plugin_params',
                                        value: data,
                                    });
                                }}
                                fields={this.state.pluginSchema}
                                submitting={{}}
                                errorMessage={{}}
                                validationErrors={{}}
                            />
                        </React.Fragment>
                    }
                    <Divider />
                    <Title type='secondary' level={3}>Field Rules</Title>
                    <div>
                        {Array.isArray(form_data.field_comparisons) && form_data.field_comparisons.map((item, index) => {

                            let item_comparator_id = item.comparator;

                            let _our_col_selections = [];
                            let _their_col_selections = [];
                            let our_col_selections = [];
                            let their_col_selections = [];


                            if (item_comparator_id) {
                                console.log(item_comparator_id, field_comparators, field_comparators[item_comparator_id])
                                let supported_type = (field_comparators[item_comparator_id] && field_comparators[item_comparator_id].supported_types) || [];
                                supported_type.map((data_type) => {
                                    let supported_ours = our_col_options[data_type] || [];
                                    _our_col_selections = _our_col_selections.concat(supported_ours);
                                    let supported_theirs = their_col_options[data_type] || [];
                                    _their_col_selections = _their_col_selections.concat(supported_theirs);
                                    console.log("assigning data", _our_col_selections, _their_col_selections)
                                });
                                our_col_selections = _our_col_selections;
                                their_col_selections = _their_col_selections;
                            }
                            return <div>
                                <Row type='flex' justify='space-between' key={index} style={{
                                    flexWrap: 'nowrap'
                                }}>
                                    <div style={{
                                        // displa:'flex',
                                        // flex:1,
                                        flexDirection: 'column',
                                        textAlign: 'right'
                                    }}>
                                        <span>Field Comparator: &nbsp;
                                    <Select placeholder="Comparator" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.comparator}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'field_comparisons',
                                                        key: 'comparator',
                                                        value: value,
                                                        index: index
                                                    });
                                                    this.ruleUpdater({
                                                        ruleKey: 'field_comparisons',
                                                        key: 'params',
                                                        value: {},
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {Object.keys(field_comparators).map((key, comp_index) => {
                                                    let item = field_comparators[key] || {};
                                                    return <Select.Option value={item.id} key={comp_index}>
                                                        {item.name}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>
                                        <br></br><br></br>
                                        <span>Our Column: &nbsp;
                                    <Select placeholder="Our Column" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.our_column}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'field_comparisons',
                                                        key: 'our_column',
                                                        value: value,
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {our_col_selections.map((item) => {
                                                    return <Select.Option value={item.key} key={item.key}>
                                                        {`${item.display_name} (${item.type})`}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>
                                        <br></br><br></br>
                                        <span>Their Column: &nbsp;
                                    <Select placeholder="Their Column" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.their_column}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'field_comparisons',
                                                        key: 'their_column',
                                                        value: value,
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {their_col_selections.map((item) => {
                                                    return <Select.Option value={item.key} key={item.key}>
                                                        {`${item.display_name} (${item.type})`}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>

                                    </div>
                                    <Tooltip title="Delete this rule">
                                        <Button type='link'
                                            onClick={() => {
                                                this.ruleDeleter({ ruleKey: 'field_comparisons', index: index })
                                            }}
                                            style={{
                                                color: 'red'
                                            }}>x</Button>
                                    </Tooltip>
                                </Row>
                                {field_comparators[item.comparator] && field_comparators[item.comparator].validation_config &&
                                    Object.keys(field_comparators[item.comparator].validation_config).length > 0
                                    && <div style={{
                                        // paddingLeft:30,
                                        // paddingRight:30
                                    }}>
                                        <Title type='secondary' level={4} underline>Validations</Title>

                                        {this._generateValidationForm(field_comparators[item.comparator].validation_config, item.params || {}, (data) => {
                                            this.ruleUpdater({
                                                ruleKey: 'field_comparisons',
                                                key: 'params',
                                                value: data,
                                                index: index
                                            });
                                            // this.ruleUpdater('params', data, index)
                                        })}
                                    </div>}
                                <Divider style={{ marginTop: 8, marginBottom: 8 }} />
                            </div>
                        })
                        }
                        <center><Button type='link' onClick={() => {
                            this.ruleAdder({ ruleKey: 'field_comparisons' })
                        }}>Add New Field Rule</Button></center>
                    </div>

                    <Divider />
                    <Title type='secondary' level={3}>Value Rules</Title>
                    <div>
                        {Array.isArray(form_data.value_comparisons) && form_data.value_comparisons.map((item, index) => {

                            let item_comparator_id = item.comparator;

                            let _our_col_selections = [];
                            let _their_col_selections = [];
                            let our_col_selections = [];
                            let their_col_selections = [];


                            if (item_comparator_id) {
                                console.log(item_comparator_id, value_comparators, value_comparators[item_comparator_id])
                                let supported_type = (value_comparators[item_comparator_id] && value_comparators[item_comparator_id].supported_types) || [];
                                supported_type.map((data_type) => {
                                    let supported_ours = our_col_options[data_type] || [];
                                    _our_col_selections = _our_col_selections.concat(supported_ours);
                                    let supported_theirs = their_col_options[data_type] || [];
                                    _their_col_selections = _their_col_selections.concat(supported_theirs);
                                    console.log("assigning data", _our_col_selections, _their_col_selections)
                                });
                                our_col_selections = _our_col_selections;
                                their_col_selections = _their_col_selections;
                            }
                            return <div>
                                <Row type='flex' justify='space-between' key={index} style={{
                                    flexWrap: 'nowrap'
                                }}>
                                    <div style={{
                                        flexDirection: 'column',
                                        textAlign: 'right'
                                    }}>
                                        <span>Value Comparator: &nbsp;
                                            <Select placeholder="Comparator" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.comparator}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'value_comparisons',
                                                        key: 'comparator',
                                                        value: value,
                                                        index: index
                                                    });
                                                    this.ruleUpdater({
                                                        ruleKey: 'value_comparisons',
                                                        key: 'params',
                                                        value: {},
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {Object.keys(value_comparators).map((key, comp_index) => {
                                                    let item = value_comparators[key] || {};
                                                    return <Select.Option value={item.id} key={comp_index}>
                                                        {item.name}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>
                                        <br></br><br></br>
                                        {item.comparator&&<React.Fragment> <span>For Source: &nbsp;
                                    <Select placeholder="For Source" style={{
                                            width: 300,
                                            paddingRight: 4
                                        }}
                                            value={item.for}
                                            onChange={(value) => {
                                                console.log("changed",value)
                                                this.ruleUpdater({
                                                        ruleKey: 'value_comparisons',
                                                        key: 'for',
                                                        value: value,
                                                        index: index
                                                });
                                                this.ruleUpdater({
                                                    ruleKey: 'value_comparisons',
                                                    key: 'column',
                                                    value: null,
                                                    index: index
                                            })
                                            }}
                                        >
                                            <Select.Option value={'our'} key={'our'}>
                                                    Our Source
                                                </Select.Option>
                                                <Select.Option value={'their'} key={'their'}>
                                                   Their Source
                                                </Select.Option>
                                        </Select>
                                    </span>
                                    <br></br><br></br>
                                    </React.Fragment>
                                }

                                {item.for==='our'?<React.Fragment><span>Our Column: &nbsp;
                                    <Select placeholder="Our Column" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.column}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'value_comparisons',
                                                        key: 'column',
                                                        value: value,
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {our_col_selections.map((item) => {
                                                    return <Select.Option value={item.key} key={item.key}>
                                                        {`${item.display_name} (${item.type})`}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>
                                        <br></br><br></br>
                                        </React.Fragment>
                                    :
                                    item.for==='their'?<React.Fragment> <span>Their Column: &nbsp;
                                    <Select placeholder="Their Column" style={{
                                                width: 300,
                                                paddingRight: 4
                                            }}
                                                value={item.column}
                                                onChange={(value) => {
                                                    this.ruleUpdater({
                                                        ruleKey: 'value_comparisons',
                                                        key: 'column',
                                                        value: value,
                                                        index: index
                                                    });
                                                }}
                                                showSearch
                                                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {their_col_selections.map((item) => {
                                                    return <Select.Option value={item.key} key={item.key}>
                                                        {`${item.display_name} (${item.type})`}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </span>
                                        <br></br><br></br>
                                        </React.Fragment>
                                        :null
                                    }

                                    </div>
                                    <Tooltip title="Delete this rule">
                                        <Button type='link'
                                            onClick={() => {
                                                this.ruleDeleter({ ruleKey: 'value_comparisons', index: index })
                                            }}
                                            style={{
                                                color: 'red'
                                            }}>x</Button>
                                    </Tooltip>
                                </Row>
                                {value_comparators[item.comparator] && value_comparators[item.comparator].validation_config &&
                                    Object.keys(value_comparators[item.comparator].validation_config).length > 0
                                    && <div style={{
                                        // paddingLeft:30,
                                        // paddingRight:30
                                    }}>
                                        <Title type='secondary' level={4} underline>Validations</Title>

                                        {this._generateValidationForm(value_comparators[item.comparator].validation_config, item.params || {}, (data) => {
                                            this.ruleUpdater({
                                                ruleKey: 'value_comparisons',
                                                key: 'params',
                                                value: data,
                                                index: index
                                            });
                                            // this.ruleUpdater('params', data, index)
                                        })}
                                    </div>}
                                <Divider style={{ marginTop: 8, marginBottom: 8 }} />
                            </div>
                        })
                        }
                        <center><Button type='link' onClick={() => {
                            this.ruleAdder({ ruleKey: 'value_comparisons' })
                        }}>Add New Value Rule</Button></center>
                    </div>

                    <Row type='flex' justify='space-between' style={{
            paddingLeft: 8,
            paddingRight: 8
        }}>
           <Button type='link' style={{ color: 'red' }}
                    onClick={() => {
                        typeof this.props.onClose==='function' && this.props.onClose()
                    }}
                >Cancel</Button>

            <Button type='primary'
                    onClick={() => {
                        this.handlePostPatch()
                    }}
                >Submit</Button>
                </Row>
                </div>
            </div>
        );
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.data !== prevProps.data || this.props.action_id !== prevProps.action_id) {
            this.setState({
                form_data: this.props.data?JSON.parse(JSON.stringify(this.props.data)): {
                    field_comparisons: [],
                    value_comparisons: [],
                    rule_id: this.props.recon_id
                },
                recon_id: this.props.recon_id,
                edit_id: this.props.action_id,
            });
            this.list_actionplugins.config({
                params: {
                    id: (this.props.data && this.props.data.id)
                }
            }).execute();

            // console.log("changes found",this.props)
        }
    }


}

export default withDomains(ReconcilerSmartActionsAddEdit, "settings");
